import store from './store';
import StoreFinderApp from './components/StoreFinderApp.vue';
import UiButton from '../components/UiButton.vue';
import Vue from 'vue';
import VueMq from 'vue-mq';

Vue.use(VueMq, {
	breakpoints: {
		"mobile": 768,
		"tablet": 1024,
		"desktop": Infinity
	}
});

Vue.component('UiButton', UiButton);

const storeFinder = new Vue({
	el: "#storeFinderApp",
	store,
	render: h => h(StoreFinderApp),
	created() {
		if (!window) return;
		const { commit, dispatch } = store;
		commit('localStore', window.localStore);
		commit('googleApiKey', window.googleApiKey);
		commit('isCrawler', window.isCrawler);
		commit('allStores', window.allStores);
		dispatch('findStore', '');
	}
});